import React from 'react';
import PropTypes from 'prop-types';


import {LoadingScreen} from 'components/controls';
import mergeStyles from 'components/helpers/mergeStyles';

import ourStyles from './TabContainer.scss';
import TabList from './TabList';
import TabPanel from './TabPanel';

/**
 * A component that renders a tab menu and a tab panel. Children will be rendered inside of the TabPanel.
 * @constructor
 */
const TabContainer = (props) => {
    const {
        tabs,
        isLoading,
        currentTabId,
        onTabChange,
        classes,
        children,
        onDrop,
    } = props;
    const styles = mergeStyles(ourStyles, classes);

    if (Object.keys(tabs).length === 0 || isLoading) return <LoadingScreen />;

    return (
        <div className={styles.tabContainer}>
            <TabList
                className={styles.tabList}
                itemClassName={styles.tabListItem}
                selectedItemClassName={styles.selectedTabListItem}
                tabs={tabs}
                currentTabId={currentTabId}
                onTabChange={onTabChange}
                onDrop={onDrop}
            />
            <TabPanel
                className={styles.tabPanel}
            >
                {children}
            </TabPanel>
        </div>
    );
};

TabContainer.propTypes = {
    /**
     * @property {object} classes  An object with scss classname mapping. Allows customizing styles of this component.
     * @see TabContainer.scss  For reference on used scss classes.
     */
    classes: PropTypes.shape({
        tabListItem: PropTypes.string,
        selectedTabListItem: PropTypes.string,
    }),
    /**
     * The tabs object, that is used to actually render the tabs.
     * Required properties:
     * @property {string}  label The text to use in the tab menu itself.
     */
    tabs: PropTypes.object.isRequired,
    currentTabId: PropTypes.string.isRequired,
    onDrop: PropTypes.func,

    isLoading: PropTypes.bool,
};

TabContainer.defaultProps = {
    classes: {},
    isLoading: false,
};

export default TabContainer;



// WEBPACK FOOTER //
// ./src/components/controls/TabContainer/TabContainer.jsx